import React from 'react';
import {clsx} from 'clsx';
import {Card, CardBody, CardHeader, Table} from '@goproblems/ui';
import {CustomPagination} from '@components/CustomPagination';
import {NothingHere} from '@components/NothingHere';

export const PaginatedTable = ({
    header,
    columns,
    rows,
    totalRecords,
    offset,
    perPage,
    pageChangeHandler,
    className,
    headerClassName,
    bodyClassName,
    tableClassName,
    showPagination = true,
    footer,
    mobileContent,
    embedded = false,
}: {
    header?: React.JSX.Element;
    columns: (string | React.JSX.Element)[];
    rows: React.JSX.Element[];
    totalRecords: number;
    offset: number;
    perPage: number;
    pageChangeHandler: (offset: number) => void;
    className?: string;
    headerClassName?: string;
    bodyClassName?: string;
    tableClassName?: string;
    showPagination?: boolean;
    footer?: React.ReactNode;
    mobileContent?: React.ReactNode;
    embedded?: boolean;
}) => {
    const headerElement = (headerEntries: (string | React.JSX.Element)[]) => {
        return (
            <thead>
                <tr>
                    {headerEntries.map((headerEntry, index) => (
                        <th key={index}>{headerEntry}</th>
                    ))}
                </tr>
            </thead>
        );
    };

    const bodyElement = (rows: React.JSX.Element[]) => {
        return (
            <tbody>
                {rows.length === 0 ? (
                    <tr>
                        <td colSpan={columns.length}>
                            <NothingHere />
                        </td>
                    </tr>
                ) : (
                    rows.map(row => row)
                )}
            </tbody>
        );
    };

    const Container = embedded ? 'div' : Card;

    return (
        <Container className={clsx(!embedded && 'mb-4', className)}>
            {header && (
                <CardHeader className={headerClassName}>{header}</CardHeader>
            )}
            <CardBody className={bodyClassName}>
                <div
                    className={
                        mobileContent ? 'dashboard-table-view' : undefined
                    }>
                    <Table className={clsx('mt-2', tableClassName)} responsive>
                        {headerElement(columns)}
                        {bodyElement(rows)}
                    </Table>
                </div>
                {mobileContent && (
                    <div className="dashboard-mobile-list">{mobileContent}</div>
                )}
                {footer}
                {showPagination && (
                    <CustomPagination
                        handlePageChange={pageChangeHandler}
                        totalRecords={totalRecords}
                        offset={offset}
                        recordsPerPage={perPage}
                    />
                )}
            </CardBody>
        </Container>
    );
};
